export default __webpack_public_path__ + "static/media/img_11.6e3a9422.jpg";